import React from 'react'

import { FilterDropdown } from '@components/common/FilterDropdown'
import { Checkbox } from '@fourthwall/components'
import { useFormik } from '@fourthwall/utils/dist/formik'

import { useFilterContributions } from '../../hooks/useFilterContributions'
import * as S from './OrdersFilter.styled'
import type { FilterFormValues } from './OrdersFilter.types'
import { ORDER_TYPE_MAP, SALES_CHANNEL_MAP, STATUS_MAP } from './consts'
import { mapEntriesToOptions } from './utils/mapEntriesToOptions'

export const OrdersFilter = () => {
  const { filtersParams, setFiltersParams, resetFiltersParams, hasFilterParams } =
    useFilterContributions()

  const initialValues: FilterFormValues = {
    status: filtersParams.status ? filtersParams.status.split(',') : [],
    salesChannel: filtersParams.salesChannel ? filtersParams.salesChannel.split(',') : [],
    type: filtersParams.type ? filtersParams.type.split(',') : [],
  }

  const handleSubmit = (values: FilterFormValues) => {
    setFiltersParams({
      status: values.status.length ? values.status.join(',') : undefined,
      salesChannel: values.salesChannel.length ? values.salesChannel.join(',') : undefined,
      type: values.type.length ? values.type.join(',') : undefined,
    })
  }

  const formik = useFormik<FilterFormValues>({
    initialValues,
    onSubmit: handleSubmit,
  })

  const statuses = Object.entries(STATUS_MAP).map(mapEntriesToOptions)
  const salesChannels = Object.entries(SALES_CHANNEL_MAP).map(mapEntriesToOptions)
  const types = Object.entries(ORDER_TYPE_MAP).map(mapEntriesToOptions)

  const handleReset = () => {
    formik.resetForm()
    resetFiltersParams()
  }

  const handleCheckboxGroupChange = (checked: boolean, value: string, name: string) => {
    const fieldValue = checked
      ? [...(formik.values as any)[name], value]
      : (formik.values as any)[name].filter((v: any) => v !== value)

    formik.setFieldValue(name, fieldValue)
  }

  return (
    <FilterDropdown
      content={
        <S.Form>
          <S.FiltersColumn>
            <div>
              <FilterDropdown.GroupTitle title="Status" />
              <S.CheckboxGroup role="group">
                {statuses.map((status) => (
                  <Checkbox
                    native
                    key={status.value}
                    label={status.label}
                    value={status.value}
                    checked={formik.values.status.includes(status.value)}
                    onValueChange={(checked) =>
                      handleCheckboxGroupChange(checked, status.value, 'status')
                    }
                  />
                ))}
              </S.CheckboxGroup>
            </div>
          </S.FiltersColumn>

          <S.FiltersColumn>
            <div>
              <FilterDropdown.GroupTitle title="Sales channel" />
              <S.CheckboxGroup role="group">
                {salesChannels.map((salesChannel) => (
                  <Checkbox
                    native
                    key={salesChannel.value}
                    label={salesChannel.label}
                    value={salesChannel.value}
                    checked={formik.values.salesChannel.includes(salesChannel.value)}
                    onValueChange={(checked) =>
                      handleCheckboxGroupChange(checked, salesChannel.value, 'salesChannel')
                    }
                  />
                ))}
              </S.CheckboxGroup>
            </div>
            <div>
              <FilterDropdown.GroupTitle title="Sample orders" />
              <S.CheckboxGroup role="group">
                {types.map((type) => (
                  <Checkbox
                    native
                    key={type.value}
                    label={type.label}
                    value={type.value}
                    checked={formik.values.type.includes(type.value)}
                    onValueChange={(checked) =>
                      handleCheckboxGroupChange(checked, type.value, 'type')
                    }
                  />
                ))}
              </S.CheckboxGroup>
            </div>
          </S.FiltersColumn>
        </S.Form>
      }
      activityIndicator={hasFilterParams}
      onSubmit={formik.handleSubmit}
      onReset={handleReset}
    />
  )
}
